module.exports = __webpack_public_path__ + "static/media/customize_chatbot_help1.8105600f.png";